export const CATEGORY_IMAGE_SIZE_ICON = 56
export const CATEGORY_IMAGE_SIZE_CARD = 120

export type CloudflarePictureCategorySizes =
  | typeof CATEGORY_IMAGE_SIZE_ICON
  | typeof CATEGORY_IMAGE_SIZE_CARD
